import {createSvgIcon} from '../create-svg-icon';

export const OpenInFullIcon = createSvgIcon(
  <path d="M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z" />
, 'OpenInFullOutlined');
